module.exports = __webpack_public_path__ + "static/media/bg4.cf955534.png";